

export class IllustrationRequestInputMetadata {
    AccountManager: user;
    DivisionalManager: user;

    constructor() {
        this.AccountManager = { firstName: "", lastName: "", email: "", id:"" };
        this.DivisionalManager = { firstName: "", lastName: "", email: "", id:"" };
    }
}

export interface user {
    firstName: string,
    lastName: string,
    email: string,
    id:string
  }